import { BookButtonTest } from "../components/meetings-test/BookButtonTest";

export const BookingTestPage = () => {
  return (
    <div className="w-full min-h-screen max-h-screen p-5 flex items-center justify-center relative">
      <p className="text-[40px] text-white text-center">
        THIS IS A TEST PAGE FOR BOOKING MEETING.
      </p>
      <BookButtonTest />
    </div>
  );
};
